export default __webpack_public_path__ + "static/media/HD_PRO_Mini.e280a2d5.png";